import { getHostForDataCenter } from 'cio/utils/data-centers';
import ApplicationAdapter from './application';
import { DataCenter } from 'cio/models/account';

export default class SsoConfigurationAdapter extends ApplicationAdapter {
  // there is always only 0 or 1 SSO configuration for an account, and all of its CRUD API calls are available under the same path:
  buildURL() {
    // Using the US data center due to timeout issues with the EU data center.
    // https://github.com/customerio/opsbugs/issues/4138
    return `${getHostForDataCenter(DataCenter.US)}/${this.namespace}/accounts/${
      this.account.current.id
    }/sso_configuration`;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'sso-configuration': SsoConfigurationAdapter;
  }
}
